module.exports = __webpack_public_path__ + "static/media/39.8d43c006.svg";